import type { ColumnType } from 'antd/es/table';

import { DataTable } from 'components/ui/organisms/DataTable';

export function SearchResults<T>({
  idKey,
  title,
  detailComponent,
  data,
  e2eId,
  isFetching,
  columnsDefinition,
  onRowClick = () => {},
  isSelected = () => false
}: {
  idKey: string;
  title: string;
  data: Array<T>;
  e2eId: string;
  isFetching: boolean;
  columnsDefinition: ColumnType<T>[];
  onRowClick?: (record: T) => void;
  detailComponent?: JSX.Element;
  isSelected?: (a: T) => boolean;
}) {
  const selectedRow = data.find(isSelected);

  return (
    <div className="flex flex-col gap-2">
      <p className="text-lg font-bold">{title}:</p>
      <DataTable
        total={data.length}
        dataSource={data}
        columns={columnsDefinition}
        onRowClick={onRowClick}
        isLoading={isFetching}
        rowKey={idKey as keyof T & string}
        selectedRow={selectedRow}
        tableDataTestId={e2eId}
        rightPanel={detailComponent}
      />
    </div>
  );
}
